module.exports = "<app-my-device-for-sale *ngFor=\"let dev of devices\" [device]=\"dev\">\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/content/new-offer/my-devices-data-base/my-devices-catalogue/my-devices-catalogue.component.html
// module id = ./src/app/content/new-offer/my-devices-data-base/my-devices-catalogue/my-devices-catalogue.component.html
// module chunks = main